


































import { index } from '@/api/users'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class extends Vue {
  config: Record<string, any> = {
    api: index,
    include: 'store',
    paginate: true,
    fields: [
      { prop: 'id', label: '#', width: 100 },
      { prop: 'uid', label: 'UID', width: 100 },
      { prop: 'avatar', label: 'T', slot: true, width: 60 },
      { prop: 'name', label: '名称' },
      { prop: 'mobile', label: '手机号码', width: 150 },
      { prop: 'gender', label: '性别', slot: true, width: 100 },
      { prop: 'balance_current', label: '余额', width: 100 },
      { prop: 'integral_current', label: '积分', width: 100 },
      { prop: 'store', label: '门店', slot: true, width: 150 },
      { prop: 'created_at', label: '注册时间', width: 200 }
    ]
  }
}
